module.exports = __webpack_public_path__ + "00ee35655f5dc3356170b633da8be98e.png";